import React from 'react'
import { Card, CardHeader } from '../../../../../../../../components/Card';
import Loader from '../../../../../../../../components/Loader';
import Buttons from '../../../../../../../../modules/Buttons';
import Button from '../../../../../../../../components/inputs/Button';
import { useFetch } from '../../../../../../../../hooks';

function Confirmation({ rowid, confirmation, refetchCow }) {
    const { fetching: fetchingConfirmheat, doFetch: doFetchConfirmheat } = useFetch({
        url: `/rpc/${confirmation.endpoint}`,
        method: 'POST'
    })

    const handleClickConfirmheat = confirm => async () => {
        try {
            await doFetchConfirmheat({
                data: {
                    rowid,
                    confirm
                }
            })
            await refetchCow({ loader: true })
        } catch (err) {

        }
    }

    return (
        <Card
            urgent
        >
            {
                fetchingConfirmheat ?
                    <Loader />
                    :
                    <>
                        <CardHeader>
                            {confirmation['form-label']}
                        </CardHeader>
                        <Buttons>
                            <Button
                                type='button'
                                onClick={handleClickConfirmheat(true)}
                                width='50%'
                                green
                            >
                                {confirmation.buttons.save}
                            </Button>
                            <Button
                                type='button'
                                onClick={handleClickConfirmheat(false)}
                                width='50%'
                            >
                                {confirmation.buttons.cancel}
                            </Button>
                        </Buttons>
                    </>
            }

        </Card>
    )
}

export default Confirmation
